import React from "react";
import { object } from "prop-types";

import { SectionHeading } from "../";

const SectionHelp = ({ style }) => (
  <div style={style}>
    <SectionHeading title="Help docs" icon="info-circle" />
    <div style={{ padding: "0 8px" }}>
      <a
        href={"https://pdview.atlassian.net/wiki/spaces/DAEGKB/overview"}
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        DHAEG knowledge base
      </a>
      <br />
      <a
        href={"https://pdview.atlassian.net/wiki/spaces/FPKB/overview"}
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        FCASpays knowledge base
      </a>
      <br />
      <a
        href={"https://pdview.atlassian.net/wiki/spaces/VKB/overview"}
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        vAdvisor Concept knowledge base
      </a>
      <br />
      Always feel free to contact us regarding any issue
    </div>
  </div>
);

SectionHelp.propTypes = {
  style: object
};

export default SectionHelp;



// WEBPACK FOOTER //
// ./src/components/section_help/SectionHelp.jsx